import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../gd-components/base-component/base-component";

export default class FormElementInput extends BaseComponent {

    static propTypes = {
        form: PropTypes.object,             // not required anymore to use input without form ! .isRequired,
        name: PropTypes.string,             //.isRequired,
        value: PropTypes.string,

        placeholder: PropTypes.string,
        hidePlaceholderOnFocus: PropTypes.bool,
        selectOnFocus: PropTypes.bool,
        disabled: PropTypes.bool,

        size: PropTypes.oneOf(["size-normal","small", "size-big", "big"]),
        isPassword: PropTypes.bool,
        type: PropTypes.oneOf(['text','password','number']),
        style: PropTypes.object,

        pattern: PropTypes.string,
        step: PropTypes.string,             //from number only
        maxLength: PropTypes.number,

        onChange: PropTypes.func,
        onKeyDown: PropTypes.func
    };

    static defaultProps = {
        size: "size-normal",
        isPassword: false,
        hidePlaceholderOnFocus: true
    };

    state = {
        isFocused: false
    };

    constructor(props) {
        super(props);

        if (this.props.form) {
            this.props.form.registerFormComponent(this.props.name,this);
        }
    }

    onChange = (event) => {
        const newValue = event.target.value;

        if (this.props.form) this.props.form.onFormComponentValueChange(this.props.name,newValue);
        if (this.props.onChange) this.props.onChange(newValue);
        this.forceUpdate(); // we need to re-render the field becuase it's BASIC controll
    };

    focus = () => {
        if (this.refs.realInput === document.activeElement) this.refs.realInput.blur(); //required for Chrome not to lose focus

        this.refs.realInput.focus();
    };

    // help with placeholder
    onFocus = (e) => {
        if (this.props.selectOnFocus) this.refs.realInput.select();

        if (this.props.placeholder && ((this.props.form && !this.props.form.getValue(this.props.name)) || !this.props.value)) {
            this.setState({
                isFocused: true
            });
        }
    };

    onBlur = () => {
        if (this.props.placeholder && ((this.props.form && !this.props.form.getValue(this.props.name)) || !this.props.value)) {
            this.setState({
                isFocused: false
            });
        }
    };

    render() {
        let value;

        if (this.props.form) {
            value = this.props.form.getValue(this.props.name);
        } else if (this.props.value) {
            value = this.props.value;
        }

        if (this.props.hidePlaceholderOnFocus && this.props.placeholder && !this.state.isFocused && (!value || value === '' || value === null)) {
            value = this.props.placeholder;
        }

        const classes = Classes('gd-input', this.props.className, this.props.size, {
            placeholder: (this.props.placeholder && value === this.props.placeholder),
            'is-disabled': this.props.disabled,
            //'invalid': (this.props.form && this.props.form.displayErrors && this.state._isValid==false)
        });

        const inputType = this.props.type ? this.props.type : this.props.isPassword ? "password" : "text";

        if (!value) value='';

        return (
            <input ref="realInput"
                   className={classes}
                   style={this.props.style}
                   type={inputType}
                   placeholder={this.props.hidePlaceholderOnFocus ? null : this.props.placeholder}
                   value={value}
                   disabled={this.props.disabled}
                   pattern={this.props.pattern}
                   step={this.props.step}
                   maxLength={this.props.maxLength}
                   onChange={this.onChange}
                   onKeyDown={this.props.onKeyDown}
                   onFocus={this.onFocus}
                   onBlur={this.onBlur}/>
        );
    }
};